var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-bar",class:{ mobile: !_vm.isDesktop }},[_c('v-app-bar-nav-icon',{attrs:{"large":"","dark":""},on:{"click":function($event){return _vm.$emit('toggleDrawer')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }